import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { adminRoutes, routes } from "../../constants";
import { Course } from "../../types";
import { convertUTCtoDateTime } from "../../utils/dateUtils";
import { Container } from "../container";
import Spinner from "../spinner";
import { useAppContext } from "../../contexts/appContext";

type CourseTableProps = {
  courseMapValue: Course[];
  loading?: boolean;
  filterOrganization?: string;
};
export const CourseTable: React.FC<CourseTableProps> = ({
  courseMapValue,
  loading,
  filterOrganization,
}) => {
  const { userOrganizations, setActiveOrganization, findOrganization } =
    useAppContext();
  const orgMap = new Map(
    userOrganizations?.map((org) => [org.organization.id, org.organization])
  );
  const [displayCourses, setDisplayCourses] =
    useState<Course[]>(courseMapValue);
  const hasCourses = displayCourses && displayCourses.length;

  useEffect(() => {
    if (filterOrganization === "all") {
      setDisplayCourses(courseMapValue);
    } else {
      const filteredCourses = courseMapValue.filter((course) => {
        return course?.organizationId?.toString() === filterOrganization;
      });
      setDisplayCourses(filteredCourses);
    }
  }, [filterOrganization, courseMapValue]);

  return (
    <div className="dashboard__table">
      {!loading && hasCourses ? (
        (displayCourses as Course[]).map((course) => (
          <Container isDismissable={false} key={course.slug}>
            <Link
              to={`/${routes.admin}/${adminRoutes.course}/${course.slug}`}
              className="course-link"
              onClick={(e) =>
                setActiveOrganization(findOrganization(course.organizationId))
              }
            >
              <div className="course-item">
                <div>
                  <h3>{course.name}</h3>
                  <h4>{orgMap?.get(course.organizationId).name}</h4>
                </div>
                {course.meetings.length > 0 && (
                  <>
                    <p>
                      First session:{" "}
                      {convertUTCtoDateTime(course.meetings[0].meetingTime)}
                    </p>
                    <p>
                      Final Session:{" "}
                      {convertUTCtoDateTime(
                        course.meetings[course.meetings.length - 1].meetingTime
                      )}
                    </p>
                  </>
                )}
              </div>
            </Link>
            {course.meetings.length < 1 && (
              <p>
                There are no classes scheduled for this course. You can add
                class sessions{" "}
                <Link
                  to={`/${routes.admin}/${adminRoutes.course}/${course.slug}`}
                  className="add-session-link"
                >
                  here
                </Link>
                .
              </p>
            )}
          </Container>
        ))
      ) : (
        <div className="dashboard__table-spinner">
          {!loading && !hasCourses ? (
            <div className="no-courses">
              <p>No courses</p>
            </div>
          ) : (
            <Spinner />
          )}
        </div>
      )}
    </div>
  );
};
